import { useState, useEffect } from 'react';
import { Spin, Tag, Button, message } from 'antd';
import { mobile } from '../../services/api';
import { useNavigate } from 'react-router-dom';
import './mobile.css';

const LEVEL_COLOR = { '严重': 'red', '紧急': 'purple', '警告': 'orange', '提示': 'blue' };

export default function MobileHome() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    mobile.home()
      .then((res) => setData(res.data))
      .catch((err) => message.error(err.message || '加载失败'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spin style={{ display: 'block', margin: '60px auto' }} />;

  const stats = data?.stats || {};

  return (
    <div>
      <div className="mobile-stat-grid" style={{ marginBottom: 12 }}>
        <div className="mobile-stat-item" onClick={() => navigate('/m/alarms')} style={{ cursor: 'pointer' }}>
          <div className="value" style={{ color: '#ff4d4f' }}>{stats.pending_alarms}</div>
          <div className="label">待处理告警</div>
        </div>
        <div className="mobile-stat-item" onClick={() => navigate('/m/tasks')} style={{ cursor: 'pointer' }}>
          <div className="value">{stats.my_tasks}</div>
          <div className="label">我的工单</div>
        </div>
        <div className="mobile-stat-item" onClick={() => navigate('/m/inspection')} style={{ cursor: 'pointer' }}>
          <div className="value" style={{ color: '#faad14' }}>{stats.pending_inspections}</div>
          <div className="label">待巡检</div>
        </div>
        <div className="mobile-stat-item">
          <div className="value" style={{ color: '#52c41a' }}>{stats.completed_today}</div>
          <div className="label">今日完成</div>
        </div>
      </div>

      {(data?.urgent_alarms || []).length > 0 && (
        <div className="mobile-card">
          <div style={{ fontWeight: 600, marginBottom: 10 }}>紧急告警</div>
          {data.urgent_alarms.map((a) => (
            <div key={a.id} className="mobile-list-item">
              <div>
                <div className="title">
                  <Tag color={LEVEL_COLOR[a.level] || 'default'} style={{ marginRight: 6 }}>{a.level}</Tag>
                  {a.title}
                </div>
                <div className="meta">{a.content}</div>
              </div>
            </div>
          ))}
          <Button type="primary" size="small" block className="mobile-action-btn" onClick={() => navigate('/m/alarms')}>
            前往处理
          </Button>
        </div>
      )}

      <div className="mobile-card">
        <div style={{ fontWeight: 600, marginBottom: 10 }}>最近工单</div>
        {(data?.recent_orders || []).length === 0 && (
          <div style={{ color: '#999', fontSize: 13, textAlign: 'center', padding: 16 }}>暂无工单</div>
        )}
        {(data?.recent_orders || []).map((o) => (
          <div key={o.id} className="mobile-list-item" onClick={() => navigate(`/m/tasks/${o.id}`)} style={{ cursor: 'pointer' }}>
            <div>
              <div className="title">{o.title}</div>
              <div className="meta">{o.order_no} · {o.status}</div>
            </div>
            <Tag color={o.priority === '紧急' ? 'purple' : o.priority === '高' ? 'red' : 'blue'}>{o.priority}</Tag>
          </div>
        ))}
      </div>
    </div>
  );
}
